const remotePartnerScriptId = 'regily-registration-front'
const isConnectQueryParam = 'connectPage'

export function parseLocation (url) {
  const a = document.createElement('a')
  a.href = url
  return a
}

export function getQueryParams (url) {
  if (typeof url === 'string') {
    url = parseLocation(url)
  }

  const parentQuery = url && url.search && url.search.substr(1)
  const parentQueryParams = {}

  if (parentQuery) {
    parentQuery.split('&').forEach(param => {
      param = param.split('=')

      parentQueryParams[param[0]] = param[1]
    })
  }

  return parentQueryParams
}

export function isFromRemote () {
  return !!window.regilyRemote
}

// checks if current window is embedded
export function inIframe () {
  try {
      return window.self !== window.top
  } catch (e) {
      return true
  }
}

export const partnerScriptHasConnectQuery = (partnerKey = '') => {
  const script = document.querySelector(`script[src*="${partnerKey}.js"]`)

  if (!!script && script.src) {
    const queryParams = getQueryParams(script.src)

    return queryParams.hasOwnProperty(isConnectQueryParam)
  }

  return false
}

export function getRemoteUrls () {
  const script = document.currentScript || document.querySelector(`script#${remotePartnerScriptId}`)
  const urlParams = getQueryParams(script.src)
  return urlParams && {
    registrationUrl: urlParams.partnerRegistrationUrl && decodeURIComponent(urlParams.partnerRegistrationUrl),
    redirectUrl: urlParams.partnerRedirectUrl && decodeURIComponent(urlParams.partnerRedirectUrl)
  }
}

export function getCustomData (scriptUrl) {
  try {
    const url = new URL(scriptUrl)
    return url.searchParams.get('customData')
  } catch (e) {
    return false
  }
}

export function getDynamicSettings () {
  const script = document.currentScript || document.querySelector(`script#${remotePartnerScriptId}`) || document.querySelector('script[src*=".regily.com/"]') || document.querySelector('script[src*="/playground.js"]')
  const settings = {}
  const documentDataset = document.documentElement.dataset || {}
  const scriptDataset = script ? script.dataset : {}

  for (let key in documentDataset) {
    if (key.indexOf('regily') === 0) {
      settings[key] = documentDataset[key]
    }
  }

  for (let key in scriptDataset) {
    if (key.indexOf('regily') === 0) {
      settings[key] = scriptDataset[key]
    }
  }

  return settings
}

export function updateQueryString (uri, key, value) {
  if (!uri) {
    uri = window.location.href
  }

  const a = document.createElement('a')
  const regEx = new RegExp(key + '((?:\\[[^\\]]*\\])?)(=|$)(.*)')

  let qs
  let qsLen
  let keyFound = false

  a.href = uri

  if (!a.search) {
    a.search = '?' + key + '=' + value
    return a.href
  }

  qs = a.search.replace(/^\?/, '').split(/&(?:amp;)?/)
  qsLen = qs.length

  while (qsLen > 0) {
    qsLen--
    if (!qs[qsLen]) {
      qs.splice(qsLen, 1)
      continue
    }

    if (regEx.test(qs[qsLen])) {
      qs[qsLen] = qs[qsLen].replace(regEx, key + '$1') + '=' + value
      keyFound = true
    }
  }

  if (!keyFound) {
    qs.push(key + '=' + value)
  }

  a.search = '?' + qs.join('&')

  return a.href
}

export function delegateEvent(
  rootElement,
  targetSelector,
  eventType,
  handler
) {
  const listener = function(event) {
    const element = event.target;
    const isValidTarget =
      !!element &&
      targetSelector.some(selector => element.matches && element.matches(selector));

    if (isValidTarget) {
      handler();
    }
  }

  rootElement.addEventListener(eventType, listener, false);

  return {
    remove: function () {
      rootElement.removeEventListener(eventType, listener, false)
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/browserStructure.js